import * as Yup from 'yup';

const isCheckCreate = (type) => {
  if (type === 'create') {
    return true;
  }
};
const isCheckEdit = (type) => {
  if (type === 'edit') {
    return true;
  }
};

export const validationSchemaTemporary = ({ type, t }) => Yup.object().shape({
  tempData: Yup.object().shape({
    skill_group_name: Yup.string().required(t('general.message.field_required')),
    sub_skill_group: Yup.array().of(
      Yup.object().shape({
        sub_skill_group_name: Yup.string().required(t('general.message.field_required')),
      }),
    ),
  }),
});
export const validationSchemaData = ({ type, t }) => Yup.object().shape({
  data: Yup.object().shape({
    skill_group_name: Yup.string().required(t('general.message.field_required')),
    sub_skill_group: Yup.array().of(
      Yup.object().shape({
        sub_skill_group_name: Yup.string().required(t('general.message.field_required')),
      }),
    ),
  }),
});
